import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'preview', 'previewContainer']

  connect() {
    this.inputTargets.forEach((input, index) => {
      input.addEventListener('change', () => this.preview(input, index))
    })
  }

  preview(input, index) {
    const file = input.files[0]
    const previewContainer = this.previewContainerTargets[index]
    const previewImage = this.previewTargets[index]

    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader()

      reader.onload = (e) => {
        previewImage.src = e.target.result
        previewContainer.classList.remove('hidden')
      }

      reader.readAsDataURL(file)
    } else {
      previewContainer.classList.add('hidden')
    }
  }
}
